export const toolbarOptions = {
  SEARCH_MANAGER: "search_manager",
  LAYERS_MANAGER: "layers_manager",
  DRAWING_TOOL: "drawing_tool",
  MEASUREMENT_TOOL: "measurement_tool",
  ADDITIONAL_IMAGES: "additional_images",
  BRIGHTNESS_CONTRAST_TOOL: "brightness_contrast_toolbar",
  ENHANCE_TOOL: "enhance_toolbar",
  FILTER_TOOL: "filter_toolbar",
  NONE: "none",
  PROJECT_MANAGER: "project_manager",
  COLLECTION_MANAGER: "collection_manager",
  INFO_PROPERTIES_MANAGER: "info_properties_manager",
  EXPORT_GEOTIFF: "export_geotiff",
  USER_DATA_MANAGER: "user_data_manager",
  DEVELOPER_PANEL: "developer_panel",
  SEARCH_ENHANCED_RESULTS: "search_enhanced_results_toolbar",
  SEARCH_ENHANCED_HEATMAP_CONFIG: "search_enhanced_heatmap_config",
  AI_CHAT: "ai_chat_toolbar",
  CUSTOM_ELEMENTS_DETECTION: "custom_elements_detection",
};
